import { render } from "./ConsentManager.vue?vue&type=template&id=99b0f0de"
import script from "./ConsentManager.vue?vue&type=script&lang=js"
export * from "./ConsentManager.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__